<template lang="pug">
  el-form#custom-content(
    :model="formAnswer"
    :rules="rules"
    ref="formAnswer")

    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap;")
        // Left-hand equation
        math-quill-view#answer-subtext(
          v-if="questionData.lefthand"
          :value="questionData.lefthand"
          style="padding-right: 15px; margin-top: 1%;"
          )

        // Answer
        el-badge(
          :value="badgeValue"
          :type="badgeType"
          :hidden="hideBadge"
          style="width: 400px;")

          el-form-item(prop="answer")
            math-quill-input(
              v-if="questionData.allow_math_equivs"
              v-model="formAnswer.answer"
              :custom-symbols="custom_symbols || []"
              @onMathInputEnter="onSubmitValidate('formAnswer')"
              placeholder="Enter the correct answer")
            el-input(
              v-else
              v-model="formAnswer.answer"
              placeholder="Enter the correct answer")
        
        // Right-hand equation
        math-quill-view#answer-subtext(
          v-if="questionData.righthand"
          :value="questionData.righthand"
          style="padding-left: 15px;  margin-top: 1%;"
        )

    // Buttons
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;")
        el-button-group(style="margin: 30px 15px 0 0")
            el-button(
              icon="el-icon-error"
              :loading="processing"
              :disabled="finished"
              @click="clearForm")
                small Clear
            el-button(
              type="primary"
              icon="el-icon-document"
              :loading="processing"
              :disabled="finished"
              @click="onSubmitValidate('formAnswer')")
                small Submit

</template>

<script>
import MathQuillInput from "@/components/utils/MathQuillInput";
import MathQuillView from "@/components/utils/MathQuillView";

export default {
  name: "AnswerInputView",

  components: {
    MathQuillInput,
    MathQuillView
  },

  props: {
    mainInfo: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      custom_symbols: [],
      hideBadge: true,
      badgeType: "success",
      badgeValue: "✓",
      formAnswer: {
        answer: ""
      },
      rules: {
        answer: [
          {
            required: true,
            message: "Please type your answer.",
            trigger: "blur"
          }
        ]
      },
      processing: false,
      finished: false
    };
  },

  computed: {
    questionData() {
      return this.mainInfo.fields;
    },

    questionScore() {
      return this.mainInfo.score == undefined
        ? 1
        : this.mainInfo.score == undefined;
    }
  },

  watch: {
    mainInfo() {
      this.updatecustom_symbols();
      this.$refs.formAnswer.resetFields();
      this.hideBadge = true;
      this.processing = false;
      this.finished = false;
    }
  },

  mounted() {
    this.updatecustom_symbols();
  },

  methods: {
    onSubmitValidate(formName) {
      this.hideBadge = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.processing = true;
          this.axios
            .post(this.$mainServer + "demo/check", {
              answer: this.formAnswer.answer,
              isAnswered: this.mainInfo.isAnswered,
              questionData: {
                type_id: this.mainInfo.type_id,
                correct_answer: this.mainInfo.correct_answer,
                allow_math_equivs: this.questionData.allow_math_equivs,
                lefthand: this.questionData.lefthand,
                score: this.questionScore
              }
            })
            .then(result => {
              this.$emit("questionSubmitted", {
                id: this.mainInfo.id,
                score: result.data.score
              });
              this.hideBadge = false;

              if (result.data.score >= this.questionScore) {
                this.badgeType = "success";
                this.badgeValue = "✔";
              } else {
                this.badgeType = "danger";
                this.badgeValue = "✘";
              }
              this.processing = false;
            })
            .catch(error => {
              this.$notify({ type: "error", message: error.message });
              this.processing = false;
            });
        } else {
          return false;
        }
      });
    },

    clearForm() {
      this.$refs.formAnswer.resetFields();
      this.hideBadge = true;
    },

    addCustomSymbol(newSymbol) {
      if (newSymbol) {
        this.custom_symbols.push([newSymbol, newSymbol, [newSymbol]]);
      }
    },

    updatecustom_symbols() {
      this.custom_symbols = [];
      if (
        this.questionData.custom_symbols !== undefined &&
        this.questionData.custom_symbols.length > 0
      ) {
        this.questionData.custom_symbols.forEach(item => {
          this.addCustomSymbol(item);
        });
      }
    }
  }
};
</script>

<style>
#answer-subtext {
  font-size: 1.25em;
}

#answer-box {
  min-width: 120px;
  font-size: 16px;
  padding: 8px 15px 8px 15px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
}
</style>
